import { Link } from "react-router-dom";
import SEO from "../components/SEO";

function Section({ title, children }) {
  return (
    <div className="mb-8">
      <h2 className="text-xl md:text-2xl font-display font-bold text-forest mb-3">{title}</h2>
      <div className="text-charcoal-soft leading-relaxed space-y-3">{children}</div>
    </div>
  );
}

export default function CorrectionsPolicy() {
  const origin = typeof window !== "undefined" ? window.location.origin : "";
  return (
    <>
      <SEO
        title="Corrections & Updates Policy | Pennsylvania Accident Aid"
        description="How to report a factual error, how Pennsylvania Accident Aid evaluates corrections, and when an article's modified date changes."
        url={`${origin}/corrections`}
      />
      <section className="pt-12 md:pt-20 pb-16 md:pb-24 px-6 bg-bone">
        <div className="max-w-3xl mx-auto" data-testid="corrections-policy">
          <div className="overline mb-3">Corrections &amp; Updates</div>
          <h1 className="text-4xl md:text-6xl font-display font-bold text-forest tracking-tight mb-6">
            Corrections policy
          </h1>
          <p className="text-lg text-charcoal-soft leading-relaxed mb-10">
            We want our resources to be accurate. If something is wrong, we want to fix it — clearly and
            honestly.
          </p>

          <Section title="How to report an error">
            <p>If you spot a factual error, please tell us through our
            <Link to="/contact" className="text-forest font-semibold hover:text-terracotta transition-colors"> contact page</Link>.
            Include the article title or link and, if possible, the specific statement and a source, so we
            can review it quickly.</p>
          </Section>
          <Section title="How corrections are evaluated">
            <p>We review each report against primary sources — Pennsylvania statutes and appellate
            decisions for legal points, and official agency data for statistics. If the report is correct,
            we fix the article. If it is not, we may leave the content unchanged and, where helpful, clarify
            the wording.</p>
          </Section>
          <Section title="When the modified date changes">
            <p>When we make a <strong>substantive</strong> factual correction or a meaningful content update,
            we update the article's modified date so readers and search engines can see it changed. Purely
            cosmetic edits — such as fixing a typo or adjusting a byline — do not reset the modified date,
            because the substance has not changed.</p>
          </Section>
          <Section title="No disguising old content as new">
            <p>We do not re-date old articles to make them appear freshly published. A modified date reflects
            a real, substantive change. The original publication date is preserved.</p>
          </Section>

          <p className="text-xs text-charcoal-soft mt-8 leading-relaxed">
            See also our
            <Link to="/editorial-policy" className="text-forest font-semibold hover:text-terracotta transition-colors"> editorial standards</Link>.
            Pennsylvania Accident Aid is not a law firm and does not provide legal advice.
          </p>
        </div>
      </section>
    </>
  );
}
